import { SpinnerProps } from './props.js'

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const sizeClasses: Record<string, string> = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }

  return (
    <div
      className={`inline-block ${sizeClasses[size]} ${className} border-2 border-current border-t-transparent rounded-full animate-spin`}
      role="status"
      aria-label="Loading"
    />
  )
}
